import { userService } from "../services";
import config from "../config/config";

export const DashboardAction = {
  fetchUserInfo,
  client_communicatin,
  fetchRefreshCache
};

// async function fetchUserInfo(hrmsId) {
//   try {
//     const apiEndpoint = `${config.baseUrl}${config.apiName.userInfo}/${hrmsId}`;
//     const response = await userService.get(apiEndpoint);
//     if (response?.status === 200) {
//       return response.data;
//     } else {
//       return null;
//     }
//   } catch (err) {
//     console.log(err);
//     return null;
//   }
// }
async function fetchUserInfo(payload) {
  try {
    const apiEndpoint = `${config.baseUrl}${config.apiName.userInfo}`;
    const response = await userService.post(apiEndpoint,payload);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}
async function fetchRefreshCache(payload) {
  try {
    const apiEndpoint = `${config.baseUrl}${config.apiName.refreshCache}`;
    const response = await userService.post(apiEndpoint,payload);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}
async function client_communicatin(payload) {
  try {
    const apiEndpoint = `${config.baseUrl}${config.apiName.client_communicatin}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}
